const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CREATURE_TYPE_MONSTROSITY,
  CREATURE_TYPE_SORROW_SWORN,
} = require('./../../../../creatureTypeIdList')
const {
  DAMAGE_PIERCING,
  DAMAGE_WEAPON_DARK,
} = require('./../../../../damageTypeList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {ALIGNMENT_NE} = require('./../../../../aligmentList')
const {ARMOR_TYPE_NATURAL} = require('./../../../../armorTypeList')
const {CR_1_4} = require('./../../../../crList')
const {CREATURE_THE_WRETCHED} = require('./../../../../creatureIdList')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_SMALL} = require('./../../../../sizeList')
const {sorrowSwornDescriptionList} = require('./../../../../textCommonParts')
const {SOURCE_MTOF} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')

module.exports = {
  name: 'Жалкий',
  nameAlt: 'Мерзость',
  nameEn: 'The Wretched',
  id: CREATURE_THE_WRETCHED,
  description: [
    `Отвратительные маленькие чудовища, Жалкие, собираются в большие стаи и охотятся по Царству Теней в поисках добычи. Эти убогие существа кормятся жизненной силой, поэтому, когда они находят подходящее существо, немедленно бросаются на него, желая погрузить клыки в его плоть для того, чтобы поглотить его жизненную силу и испытываемый страх.`,
      ...sorrowSwornDescriptionList,
  ],
  sizeType: SIZE_SMALL,
  creatureTypeIdList: [
    CREATURE_TYPE_MONSTROSITY,
    CREATURE_TYPE_SORROW_SWORN,
  ],
  alignmentId: ALIGNMENT_NE,
  source: {
    id: SOURCE_MTOF,
    page: 238,
  },
  armor: {
    ac: 15,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 4,
  },
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 7,
    [PARAM_DEX]: 12,
    [PARAM_CON]: 9,
    [PARAM_INT]: 5,
    [PARAM_WIT]: 6,
    [PARAM_CHA]: 5,
  },
  resistanceList: [
    DAMAGE_WEAPON_DARK,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  cr: CR_1_4,
  featureList: [
    {
      name: 'Жалкая тактика стаи',
      description: `Жалкий совершает броски атаки против существ с преимуществом, если в пределах 5 фт. от существа находится дееспособный союзник Жалкого. В противном случае, он совершает броски атаки с помехой.`,
    },
  ],
  actionList: [
    {
      name: 'Укус',
      description: `Жалкий прицепляется к цели. Пока он находится в таком положении, жалкий не может атаковать, но в начале каждого хода Жалкого цель получает 6 (1к10 + 1) урона некротической энергией.

Прицепившийся Жалкий передвигается вместе с целью, куда бы цель не направлялась, без траты движения Жалкого. Жалкий может отцепиться, потратив 5 фт. движения на своём ходу. Существа, включая саму цель, могут использовать действие, чтобы отцепить Жалкого.`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 3,
        range: 5,
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 1,
          diceType: 10,
          diceBonus: 1,
        },
      },
    },
  ],
}
